export const PHARMA_META_DESCRIPTION =
  "Media monitoring and media analysis for pharma in SEE - reputation analysis, regulation, crisis monitoring and disease awareness coverage. Brief our analysts.";
